var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[
    ("btn-" + _vm.variant),
    ("btn-" + _vm.size),
    _vm.width,
    { 'btn-icon-only': _vm.iconOnly } ],on:{"click":function($event){return _vm.$emit('click')}}},[((_vm.icon || _vm.iconOnly) && !_vm.loading)?_c('div',{staticClass:"btn-icon",class:{ 'btn-icon-right': _vm.iconRight }},[_vm._t("icon")],2):_vm._e(),(!_vm.iconOnly && !_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('div',{staticClass:"btn-loading"},[_c('common-spinner')],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }